import { useRecoilValue } from 'recoil';
import { Helmet } from 'react-helmet-async';
import { settingsAtom } from '../../atoms/Settings';

export const AnalyticsHelmet = () => {
  const settings = useRecoilValue(settingsAtom);

  const googleAdsGtmID = settings.settingsV1.google_ads_gtm_id;
  const googleAnalyticsGtmID = settings.settingsV1.google_analytics_gtm_id;
  const gtmID = settings.settingsV1.gtm_id;
  const metaPixelID = settings.settingsV1.meta_pixel_tag;
  const tikTokPixelID = settings.settingsV1.tik_tok_pixel_id;

  const scripts: JSX.Element[] = [];

  // Meta Pixel
  if (metaPixelID) {
    scripts.push(
      <script key='fb-pixel' type='text/javascript'>
        {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${metaPixelID}');
        fbq('track', 'PageView');
        `}
      </script>,
    );
  }

  // Google Ads GTM
  if (googleAdsGtmID) {
    scripts.push(
      <script
        key='ga-gtag-ads'
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${googleAdsGtmID}`}
      />,
      <script key='ga-gtag-ads-config' type='text/javascript'>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${googleAdsGtmID}');
        `}
      </script>,
    );
  }

  // Google Analytics GTM
  if (googleAnalyticsGtmID) {
    scripts.push(
      <script
        key='ga-gtag-analytics'
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsGtmID}`}
      />,
      <script key='ga-gtag-analytics-config' type='text/javascript'>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${googleAnalyticsGtmID}');
        `}
      </script>,
    );
  }

  // GTM Tag
  if (gtmID) {
    scripts.push(
      <script key='gtm-tag' type='text/javascript'>
        {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmID}');
        `}
      </script>,
    );
  }

  // TikTok Pixel
  if (tikTokPixelID) {
    scripts.push(
      <script key='ttq-pixel' type='text/javascript'>
        {`
!function (w, d, t) {
  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
  ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
  ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
  for(var i=0;i<ttq.methods.length;i++) ttq.setAndDefer(ttq,ttq.methods[i]);
  ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++) ttq.setAndDefer(e,ttq.methods[n]);return e};
  ttq.load=function(e,n){
    var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;
    ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=r;ttq._t=ttq._t||{};ttq._t[e]=+new Date;
    ttq._o=ttq._o||{};ttq._o[e]=n||{};
    n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src=r+"?sdkid="+e+"&lib="+t;
    e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)
  };

  ttq.load('${tikTokPixelID}');
  ttq.page();
}(window, document, 'ttq');
        `}
      </script>,
    );
  }

  return <Helmet>{scripts}</Helmet>;
};
